import { useEffect, useState } from 'react';

/** Current epoch ms, refreshed once a second while `active` so a running timer can tick. */
export function useNow(active: boolean): number {
    const [now, setNow] = useState(() => Date.now());
    useEffect(() => {
        if (!active) {
            return undefined;
        }
        const id = window.setInterval(() => {
            setNow(Date.now());
        }, 1000);
        return () => {
            window.clearInterval(id);
        };
    }, [active]);
    return now;
}
